export default "__VITE_ASSET__B9wPJq3a__"